export default {
  // apiBaseUrl: "http://localhost:7152/api",
  apiBaseUrl: "https://timekeeper.primebot.pl/api",
  token: sessionStorage.getItem('token')
}